<template lang="pug">
.web-page-skeleton
  .skeleton-header(v-if="showHeader")
    .skeleton-box.skeleton-title
    .skeleton-box.skeleton-subtitle
  
  .skeleton-content
    .skeleton-section(v-for="n in sections" :key="n")
      .skeleton-box.skeleton-section-title(v-if="showSectionTitles")
      .skeleton-grid
        .skeleton-card(v-for="i in cardsPerSection" :key="i")
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'WebPageSkeleton',
  props: {
    sections: {
      type: Number,
      default: 2,
    },
    cardsPerSection: {
      type: Number,
      default: 4,
    },
    showHeader: {
      type: Boolean,
      default: true,
    },
    showSectionTitles: {
      type: Boolean,
      default: true,
    },
  },
});
</script>

<style lang="scss" scoped>
.web-page-skeleton {
  width: 100%;
  padding: 32px 24px 64px;
  max-width: 1400px;
  margin: 0 auto;

  @media (min-width: 768px) {
    padding: 40px 40px 80px;
  }

  @media (min-width: 1024px) {
    padding: 48px 64px 96px;
  }
}

.skeleton-header {
  margin-bottom: 48px;
  text-align: center;

  @media (min-width: 768px) {
    margin-bottom: 56px;
  }

  @media (min-width: 1024px) {
    margin-bottom: 64px;
  }
}

.skeleton-box {
  background: linear-gradient(90deg, #F5F5F5 25%, #ECECEC 50%, #F5F5F5 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  border-radius: 8px;
}

.skeleton-title {
  height: 40px;
  width: 300px;
  max-width: 80%;
  margin: 0 auto 16px;

  @media (min-width: 768px) {
    height: 48px;
    width: 400px;
  }

  @media (min-width: 1024px) {
    height: 56px;
    width: 500px;
  }
}

.skeleton-subtitle {
  height: 20px;
  width: 250px;
  max-width: 70%;
  margin: 0 auto;

  @media (min-width: 768px) {
    height: 24px;
    width: 350px;
  }
}

.skeleton-content {
  display: flex;
  flex-direction: column;
  gap: 48px;

  @media (min-width: 768px) {
    gap: 56px;
  }

  @media (min-width: 1024px) {
    gap: 64px;
  }
}

.skeleton-section {
  width: 100%;
}

.skeleton-section-title {
  height: 32px;
  width: 200px;
  margin-bottom: 24px;

  @media (min-width: 768px) {
    height: 36px;
    width: 250px;
    margin-bottom: 28px;
  }

  @media (min-width: 1024px) {
    height: 40px;
    width: 300px;
    margin-bottom: 32px;
  }
}

.skeleton-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;

  @media (min-width: 768px) {
    grid-template-columns: repeat(3, 1fr);
    gap: 24px;
  }

  @media (min-width: 1024px) {
    grid-template-columns: repeat(4, 1fr);
    gap: 24px;
  }
}

.skeleton-card {
  height: 233px;
  background: linear-gradient(90deg, #F5F5F5 25%, #ECECEC 50%, #F5F5F5 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  border-radius: 12px;

  @media (min-width: 768px) {
    height: 253px;
  }

  @media (min-width: 1024px) {
    height: 267px;
  }
}

@keyframes shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}
</style>
